import React from "react";
import Header from "./Components/Header/Header";
import HomeScreen from "./Components/HomeScreen";

function App() {
  return (
    <div>
      <Header />
      <HomeScreen />
    </div>
  );
}

export default App;
